import api from './api/index';
import { router } from './router/index';

/**
 * 安全校验回调。
 * 宿主通过 setSecurityVerify 或 init.onSecurityVerify 注入；
 * 未注入时默认直接通过（不拦截）。
 * 签名：() => Promise<void>  — reject 表示校验未通过/用户取消
 */
let _onSecurityVerify = () => Promise.resolve();

export function getSecurityVerify() {
  return _onSecurityVerify;
}

export default {
  init({ device, $get, Layout, onSecurityVerify }) {
    this.device = device;
    this.$get = $get;
    api.init($get);
    router.init(Layout, device);
    if (typeof onSecurityVerify === 'function') {
      _onSecurityVerify = onSecurityVerify;
    }
  },
  /**
   * 在宿主 store 就绪后调用，注入安全校验回调。
   * @param {() => Promise<void>} fn
   */
  setSecurityVerify(fn) {
    if (typeof fn === 'function') {
      _onSecurityVerify = fn;
    }
  },
};
